import React, { useCallback, useEffect } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultPUR1040_R01Filter, PUR1040_R01Filter, usePUR1040_R01Store } from './Store_PUR1040_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { downloadExcel_PUR1040_R01, getPUR1040_R01AllCount, getPUR1040_R01DetailList, getPUR1040_R01List } from "./Api_PUR1040_R01";
import { defaultPUR1040_R01DetailDto, defaultPUR1040_R01HeaderDto, PUR1040_R01DetailDto, PUR1040_R01Dto, PUR1040_R01HeaderDto } from './Dto_PUR1040_R01';
import { filterDeletedItems } from 'src/utils/calculation/calculationUtils';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';

interface Props {
    gridRef: React.RefObject<AgGridReact<PUR1040_R01HeaderDto> | null>;
    detailGridRef: React.RefObject<AgGridReact<PUR1040_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}

export const Content_PUR1040_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { moneyCdList, vatTypeList, compCdList } = useCommonCodeStore();

	
    const {
        PUR1040_R01Filter, setPUR1040_R01Filter,
        PUR1040_R01PastFilter, setPUR1040_R01PastFilter,
        PUR1040_R01List, setPUR1040_R01List,
        editPUR1040_R01, setEditPUR1040_R01,
        selectedPUR1040_R01, setSelectedPUR1040_R01, 
        deletedPUR1040_R01DetailList, setDeletedPUR1040_R01DetailList, addDeletedPUR1040_R01DetailList, removeDeletedPUR1040_R01DetailList, 
        selectedPUR1040_R01DetailList, setSelectedPUR1040_R01DetailList, addSelectedPUR1040_R01DetailList, removeSelectedPUR1040_R01DetailList,
        PUR1040_R01DetailList, setPUR1040_R01DetailList,
        originalPUR1040_R01DetailList, setOriginalPUR1040_R01DetailList,
        allCount, setAllCount,
        initData,
        setScrollTop, setDetailScrollTop,
    } = usePUR1040_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();

    useFetchActionbarAuth("PUR1040_R01");

	const handleExcelClick = useCallback(async () => {
        if (!selectedPUR1040_R01) {
			showWarning("선택된 매출역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

			if (!selectedPUR1040_R01?.purchaseOrderNo) {
			showWarning('매출번호가 선택되지 않았습니다.');
			setLoadingSpinner(false);
			return;
		}
        const response = await downloadExcel_PUR1040_R01(selectedPUR1040_R01.purchaseOrderNo);

		downloadSettingExcel({ responseData: response.data.data, fileName: ' 발주현황-excel.xlsx' });

		setLoadingSpinner(false);
    }, [selectedPUR1040_R01])

    const getParams = (filter: PUR1040_R01Filter) => {
        const params: Partial<PUR1040_R01Filter> = {
			compCd: filter.compCd || undefined,
			itemGroup: filter.itemGroup || undefined,
			brandCd: filter.brandCd || undefined,
			empNo: filter.empNo || undefined,
			customCd: filter.customCd || undefined,
			dateRange: filter.dateRange || undefined,
			logicCenter: filter.logicCenter || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
        const response = await getPUR1040_R01AllCount(getParams(PUR1040_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
    }, [PUR1040_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLoadingSpinner(true);
	
        const responseData = (await getPUR1040_R01List(
			'',
            getParams(PUR1040_R01Filter),
			PUR1040_R01List.length ?? 0
		));


        let newList = [ ...responseData.data.data ] as PUR1040_R01HeaderDto[];
		setPUR1040_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
            gridRefSelectedRowHandler(
                gridRef,
                setSelectedPUR1040_R01,
                () => true,// 유지
            );
            setPUR1040_R01PastFilter(PUR1040_R01Filter);
			setLoadingSpinner(false);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
            setSelectedPUR1040_R01(undefined);
            setPUR1040_R01List([]);
            setPUR1040_R01DetailList([]); 
            setDeletedPUR1040_R01DetailList([]);
            setSelectedPUR1040_R01DetailList([]);
            setOriginalPUR1040_R01DetailList([]);
			setLoadingSpinner(false);
		}
        return responseData;
    }, [PUR1040_R01Filter, PUR1040_R01List, setPUR1040_R01List, setPUR1040_R01PastFilter, setSelectedPUR1040_R01, selectedPUR1040_R01, setScrollTop, setDetailScrollTop])
	

	useEffect(() => {
	
		const fetchDetailList = async (salesEstimateNo: string) => {
			setDetailScrollTop(null);
			try {
                const response = await getPUR1040_R01DetailList(salesEstimateNo);
				
				if (response.data.successFlag && response.data.data) {
					const responseData = response.data.data;
					
					if(responseData && responseData.length > 0){
                        const processedData = responseData.map((value: any, idx: number) => ({
							...value,
							valueIndex: value.valueIndex ?? idx + 1,
							orderIndex: value.orderIndex ?? idx + 1,
							orderIndexSeq: value.orderIndexSeq ?? 0,
							// 서버 값 → 화면 편집 필드 동기화
							estimatePrice: (value as any).estimatePrice ?? (value as any).itemPrice ?? 0,
							estimateQty: (value as any).estimateQty ?? (value as any).itemQty ?? 0,
							estimateUnit: (value as any).estimateUnit ?? (value as any).unit ?? '',
							itemAmt: (value as any).itemAmt ?? (((Number((value as any).estimateQty ?? (value as any).itemQty ?? 0)) * Number((value as any).estimatePrice ?? (value as any).itemPrice ?? 0)) - Number((value as any).dcAmt ?? 0)),
							// 호환 필드 유지
							itemCost: (value as any).itemPrice,
							id: (value as any).id
						}));
						
                        setPUR1040_R01DetailList(processedData);
                        setOriginalPUR1040_R01DetailList(responseData);
                        setMessage(`${selectedPUR1040_R01?.customNm}의 상세내역 ${responseData.length}건을 조회하였습니다.`);
						setTimeout(() => setMessage(""), 5000);
					} else {
						// 조회용: 데이터가 없으면 빈 배열만 설정
                        setPUR1040_R01DetailList([]);
                        setOriginalPUR1040_R01DetailList([]);
						setMessage("상세내역이 없습니다.");
						setTimeout(() => setMessage(""), 3000);
					}
				} else {
					// API 응답 실패 처리
					showError('상세내역 조회에 실패했습니다.');
                    setPUR1040_R01DetailList([]);
                    setOriginalPUR1040_R01DetailList([]);
				}
			} catch (error) {
				console.error('상세내역 조회 오류:', error);
				showError('상세내역 조회 중 오류가 발생했습니다.');
                setPUR1040_R01DetailList([]);
                setOriginalPUR1040_R01DetailList([]);
			}
		}
	
        if (selectedPUR1040_R01?.purchaseOrderNo) {
            fetchDetailList(selectedPUR1040_R01.purchaseOrderNo);
        }
    }, [selectedPUR1040_R01, setDetailScrollTop, setPUR1040_R01DetailList, setOriginalPUR1040_R01DetailList, setMessage])

	// 조회용: 신규행 추가 로직 제거
	
	return {
		handleExcelClick,
		fetchData,
	};
}
